module.exports = __webpack_public_path__ + "static/media/5-R-Smart Pro-c.4747080b.jpg";